"use client";
import { useRoutes } from "@core/hooks/useEditQueries";
import { useUser } from "@core/hooks/endpoints/useUser";
import { ReactNode, useEffect } from "react";

export default function LanguagePage({
  children,
  lang = "es",
}: {
  children: ReactNode;
  lang?: string;
}) {
  const { restaurants } = useUser();

  const { replace } = useRoutes();

  useEffect(() => {
    if (!!restaurants?.length) return replace({ url: `/${lang}/restaurants` });
    return replace({ url: `/${lang}/app` });
  }, [lang, replace, restaurants]);
  return children;
}
